// extracted by mini-css-extract-plugin
export default {"FeaturedLinksGrid":"index_FeaturedLinksGrid__pgH5n","FeaturedLink":"index_FeaturedLink__14Nxy","heading":"index_heading__2OTiD","paragraph":"index_paragraph__3b7am"};